import React, { HTMLAttributes } from 'react'
import styles from './Icon.module.scss'
import cx from 'classnames'

type IconProps = HTMLAttributes<HTMLElement> & {
  name: string
  size?:
    | 'lg'
    | 'xl'
    | 'xxs'
    | 'xs'
    | 'sm'
    | '1x'
    | '2x'
    | '3x'
    | '4x'
    | '5x'
    | '6x'
    | '7x'
    | '8x'
    | '9x'
    | '10x'
    | 'fw'
  label?: string
}

export const Icon: React.FC<IconProps> = ({ name, size = '1x', label, className, ...other }) => (
  <i
    className={cx(styles.icon, `ri-${name}`, `ri-${size}`, className)}
    aria-label={label}
    role={label ? 'img' : 'presentation'}
    {...other}
  />
)

Icon.displayName = 'Icon'
